/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { ContextMenuComponents } from '@googleforcreators/design-system';
import { useCallback } from '@googleforcreators/react';

/**
 * Internal dependencies
 */
import { RIGHT_CLICK_MENU_LABELS } from '../constants';
import { useStory } from '../..';

function LayerUngroup() {
  const { selectedElements, removeElementFromGroup } = useStory(
    ({ state, actions }) => ({
      selectedElements: state.selectedElements,
      removeElementFromGroup: actions.removeElementFromGroup,
    })
  );
  const handleLayerUngroup = useCallback(() => {
    removeElementFromGroup({
      elementId: selectedElements[0].id,
      groupId: selectedElements[0].groupId,
    });
  }, [selectedElements, removeElementFromGroup]);

  const isLayerInGroup = selectedElements.some((el) => el.groupId);

  if (!isLayerInGroup) {
    return null;
  }

  return (
    <ContextMenuComponents.MenuButton onClick={handleLayerUngroup}>
      {RIGHT_CLICK_MENU_LABELS.UNGROUP_LAYER}
    </ContextMenuComponents.MenuButton>
  );
}

export default LayerUngroup;
